const KEY = 'nailsly.pendingLicenseCode';

/** O código é mantido só na sessão do navegador (nunca na URL) até o login terminar. */
export function savePendingLicenseCode(code: string): void {
  try {
    sessionStorage.setItem(KEY, code.trim().toUpperCase());
  } catch {
    /* armazenamento indisponível: o usuário pode ativar de novo no painel */
  }
}

export function readPendingLicenseCode(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearPendingLicenseCode(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* armazenamento indisponível */
  }
}
